<template>
  <div>
    <md-toolbar
      class="md-transparent"
      md-elevation="0">
      <router-link
        to="/"
        exact
        class="logo">
        <img src="../assets/img/logo.png">
      </router-link>
    </md-toolbar>
    <md-list class="menu__sidebar">
      <md-list-item>
        <router-link :to="{ name: 'Building stock'}">
          <i class="ico ico_bati"/> Parc Bati
        </router-link>
      </md-list-item>
      <md-list-item>
        <router-link :to="{ name: 'Scenarios'}">
          <i class="ico ico_scenario"/> Scénarios
        </router-link>
      </md-list-item>
      <md-list-item>
        <router-link :to="{ name: 'PPI'}">
          <i class="ico ico_bati"/> PPI
        </router-link>
      </md-list-item>
      <md-list-item>
        <router-link :to="{ name: 'Atypical'}">
          <i class="ico ico_actions_atypique"/> Actions atypiques
        </router-link>
      </md-list-item>
      <md-list-item>
        <router-link :to="{ name: 'Base d\'actions'}">
          <i class="ico ico_actions"/> Base d'actions
        </router-link>
      </md-list-item>
    </md-list>
  </div>
</template>

<script>
export default {
  name: 'SideBar',
  props: {

  }
}
</script>

<style scoped lang="scss">
$primary: #86ad19;
.menu__sidebar {
  a {
    color: #222;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;

    &.router-link-active,
    &:hover {
      color: $primary;

      .ico_scenario {
        background-image: url(../assets/img/scenario_active.png);
      }
      .ico_bati {
        background-image: url(../assets/img/parc_active.png);
      }
      .ico_actions {
        background-image: url(../assets/img/actionsbase_active.png);
      }
      .ico_actions_atypique {
        background-image: url(../assets/img/actions_atypique_active.png);
      }

      @media only screen and (min--moz-device-pixel-ratio: 2),
        only screen and (-o-min-device-pixel-ratio: 2/1),
        only screen and (-webkit-min-device-pixel-ratio: 2),
        only screen and (min-device-pixel-ratio: 2) {
        .ico {
          background-size: contain;
        }

        .ico_scenario {
          background-image: url(../assets/img/scenario_active@2x.png);
        }

        .ico_bati {
          background-image: url(../assets/img/parc_active@2x.png);
        }

        .ico_actions {
          background-image: url(../assets/img/actionsbase_active@2x.png);
        }

        .ico_actions_atypique {
          background-image: url(../assets/img/actions_atypique_active@2x.png);
        }
      }
    }
  }
}

.logo {
  display: block;
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #eee;
  padding: 1rem;
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/SideBar.vue